/* eslint-disable @typescript-eslint/no-explicit-any */
import { API, PAGINATION } from "@/constants/common";
import { apiClient } from "../client/apiClient";

export class UploadService {
  static instance: UploadService;

  public static QUERY_KEY = {
    BASE: "upload",
    FETCH_ALL: ["upload", "fetch_all"],
    FETCH_DETAIL: ["upload", "fetch_detail"],
  };

  constructor() {
    if (UploadService.instance) {
      return UploadService.instance;
    }
    UploadService.instance = this;
  }

  async getUploadList(params: any): Promise<any> {
    const { data } = await apiClient.get(API.UPLOAD.LIST, params);
    return data;
  }

  async getUploadDetail(fileId: number | undefined): Promise<any> {
    if (!fileId) {
      return null;
    }
    // TODO: remove page and limit when backend is ready
    const data = await apiClient.get(API.UPLOAD.DETAIL(fileId), {
      page: PAGINATION.MIN_PAGE,
      limit: PAGINATION.MIN_LIMIT,
    });
    return data;
  }
}
